import AreaActions from "./AreaActions";

const AreaRow = ({ area, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{area.id}</td>
      <td
        dangerouslySetInnerHTML={{
          __html: highlightText(area.area || "-"),
        }}
      />
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            area.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {area.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <AreaActions area={area} />
        </span>
      </td>
    </tr>
  );
};

export default AreaRow;
